module.exports = __webpack_public_path__ + "static/img/xc6.dd5ce12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xc6.jpg
// module id = chhI
// module chunks = 0